import { Component, Input, OnInit, SimpleChanges } from '@angular/core';
import { PersonEnvelope } from '../../../models/net/envelope/person-envelope';
import { ItemEnvelope } from '../../../models/net/envelope/base/item-envelope';
import { CloakType } from '../../../models/data/app-core/cloak-type';
import { SearchRequestType } from '../../../models/data/app-core/search-request-type';
import { PersonSearchRequestSetting } from '../../../models/app/person-search-request-setting';
import { SearchPreference } from '../../../models/data/app-core/search-preference';
import { SearchRequest } from '../../../models/data/app-core/search-request';

@Component({
    selector: 'app-person-preferences',
    templateUrl: './person-preferences.component.html',
    styleUrls: ['./person-preferences.component.css', '../../../app.component.css']
})

export class PersonPreferencesComponent implements OnInit {

    public cloakTypes: CloakType[] = [];
    public selectedCloakType: CloakType | null = null;
    public searchRequestTypePreferences: PersonSearchRequestSetting[] = [];
    public displayedSearchRequestTypePreferences: string[] = ["Avatar", "SearchRequestTypeUID", "SearchRequestName"]; //, "IsRunSearchOnLoad"];

    @Input() public personEnvelope: PersonEnvelope | null = null;

    public constructor() { }

    public ngOnInit(): void { }

    public ngAfterViewInit(): void {

        if (this.personEnvelope) {

            this.handlePersonEnvelopeChange();
        }
    }

    public ngOnChanges(changes: SimpleChanges): void {

        if (changes['personEnvelope'] && this.personEnvelope) {

            this.handlePersonEnvelopeChange();
        }
    }

    private handlePersonEnvelopeChange(): void {

        this.cloakTypes = this.personEnvelope?.CloakTypesPool || [];

        let searchRequestTypePreferences: PersonSearchRequestSetting[] | undefined = this.personEnvelope?.SearchRequestTypesPool!.map((searchRequestType: SearchRequestType) => {

            let result: PersonSearchRequestSetting = {
                SearchRequestTypeId: searchRequestType.SearchRequestTypeId,
                SearchRequestTypeUID: searchRequestType.UID, 
                SitePreferencesSetId: this.getSitePreferenceSetIdFromEnvelope(),
                SearchPreferenceId: this.getSearchPreferenceIdBySearchRequestTypeId(searchRequestType.SearchRequestTypeId), 
                SearchRequestId: this.getSearchRequestIdBySearchRequestTypeId(searchRequestType.SearchRequestTypeId), 
                SearchRequestName: this.getSearchRequestNameBySearchRequestTypeId(searchRequestType.SearchRequestTypeId),
                IsRunSearchOnLoad: true
            } as PersonSearchRequestSetting;

            return result;
        });

        this.searchRequestTypePreferences = searchRequestTypePreferences!;
    }

    private getSitePreferenceSetIdFromEnvelope = (): number => {

        const result: number = this.personEnvelope!.Document.SitePreferencesSet.SitePreferencesSetId;

        return result;
    }

    private getSearchPreferenceIdBySearchRequestTypeId = (searchRequestTypeId: number): number | undefined => {

        let result: number | undefined = undefined;
        const searchPreference: SearchPreference | undefined = this.personEnvelope!.Document.SearchPreferences.find((sp: SearchPreference) => sp.SearchRequestTypeId === searchRequestTypeId);

        if (searchPreference) {

            result = searchPreference.SearchPreferenceId;
        }

        return result;
    }

    private getSearchRequestIdBySearchRequestTypeId = (searchRequestTypeId: number): number | undefined => {

        let result: number | undefined = undefined;
        const searchPreference: SearchPreference | undefined = this.personEnvelope!.Document.SearchPreferences.find((sp: SearchPreference) => sp.SearchRequestTypeId === searchRequestTypeId);

        if (searchPreference) {

            result = searchPreference.DefaultSearchRequestId;
        }

        return result;
    }

    private getSearchRequestNameBySearchRequestTypeId = (searchRequestTypeId: number): string | undefined => {

        let result: string | undefined = "";
        const searchPreference: SearchPreference | undefined = this.personEnvelope!.Document.SearchPreferences.find((i: SearchPreference) => i.SearchRequestTypeId === searchRequestTypeId);

        if (searchPreference) {

            const searchRequest: SearchRequest | undefined = this.personEnvelope!.SearchRequestsPool.find((i: SearchRequest) => i.SearchRequestId === searchPreference.DefaultSearchRequestId);

            if (searchRequest) {

                result = searchRequest.Name;
            }
        }

        return result;
    }

    //private getSearchRequestIsRunSearchOnLoadBySearchRequestTypeId = (searchRequestTypeId: number): boolean => {

    //    let result: boolean = false;
    //    const searchPreference: SearchPreference | undefined = this.personEnvelope!.Document.SearchPreferences.find((i: SearchPreference) => i.SearchRequestTypeId === searchRequestTypeId);

    //    if (searchPreference) {

    //        result = searchPreference.IsRunDefaultSearchOnLoad;
    //    }

    //    return result;
    //}
}
